import { render } from "./App.vue?vue&type=template&id=f1f39674"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__